import { ComponentType } from 'react';

export const enum OptionComponentEnum {
  link = 'link',
  button = 'button',
}

export type MenuOptionType = {
  label: string;
  type: OptionComponentEnum;
  Icon: ComponentType;
  routePath?: (id: string) => string;
};
